<template>
  <v-card :style="backOpacity" :color="rules[14]">
    <v-card-title>サブページの指定 SubpageForm.vue</v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="valid">
          <!-- {{ rules }} -->
          <!-- {{ values }} -->
          <v-row>
            <v-col cols="4">
              <v-text-field
                label="ラベル名"
                v-model="returnData.label"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                label="更新件数(上限.下限)上限のみ指定なら下限は1"
                v-model="rules[0]"
                :rules="[varidation.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="colors"
                class="ma-2"
                v-model="rules[14]"
                label="背景色"
              ></v-select>
            </v-col>
          </v-row>
          <v-row rols="12">
            <v-col cols="12">
              <v-radio-group label="表示タイプ" v-model="rules[1]" row>
                <v-radio label="リスト形式" value="list"></v-radio>
                <v-radio label="リスト形式(上に追加)" value="listRev"></v-radio>
                <v-radio label="モーダル形式" value="modal"></v-radio>
                <v-radio
                  label="モーダル形式(追加削除なし)"
                  value="modalOnlyOne"
                ></v-radio>
                <v-radio
                  label="複数ページ切り替え形式(モーダル)"
                  value="multiList"
                ></v-radio>
                <v-radio
                  label="モーダル形式(v-tableによる表示)"
                  value="modalTable"
                ></v-radio>
                <v-radio
                  label="マスタ登録(リスト形式を選択)"
                  value="master"
                ></v-radio>
                <v-radio
                  label="マスタ登録による日報登録"
                  value="masterView"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="rules[1] == 'multiList'">
            <v-col cols="12">
              <v-text-field
                label="切り替え条件フォームID"
                v-model="rules[2]"
                required
                :rules="[varidation.numonly]"
              ></v-text-field>
            </v-col>
            <v-btn color="success" class="ma-1" @click="del">削除</v-btn>
            <v-btn color="success" class="ma-1" @click="add">追加</v-btn>

            <div v-for="(pageID, i) in pageIDs" :key="i" class="mb-4">
              <v-text-field
                label="ページID"
                v-model="pageIDs[i]"
                required
                class="ma-1"
                :rules="[varidation.numonly]"
              ></v-text-field>
              <v-text-field
                label="条件"
                v-model="values[i]"
                required
                class="ma-1"
              ></v-text-field>
            </div>
          </v-row>
          <v-row v-else>
            <v-col cols="3">
              <search-Page
                :label="'参照ページID'"
                v-model="returnData.init"
                searchPage
              ></search-Page>
            </v-col>
            <v-col cols="5" v-if="rules[1] == 'masterView'">
              <search-Page
                :label="'マスタデータのフォームID'"
                v-model="rules[5]"
              ></search-Page>
              *同一ページにマスタ情報formが存在する場合のみ使用している
              <!-- rules[5]が被っている -->
            </v-col>
            <v-col cols="3" v-if="rules[1] == 'masterView'">
              <v-checkbox
                v-model="rules[8]"
                label="データの追加・削除"
                value="true"
              ></v-checkbox>
            </v-col>
          </v-row>
          <!---------------- モーダル表示   --------------------------->
          <div
            v-if="
              rules[1] == 'modal' ||
                rules[1] == 'modalOnlyOne' ||
                rules[1] == 'master'
            "
          >
            <v-row>
              <v-col cols="3">
                <v-text-field
                  label="縦サイズ"
                  v-model.number="options.height"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="横サイズ"
                  v-model.number="options.width"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <p>ボタンの色</p>
              <v-col cols="3">
                <v-select
                  :items="colors"
                  class="ma-2"
                  v-model="options.color.add"
                  label="追加"
                ></v-select
              ></v-col>
              <v-col cols="3">
                <v-select
                  :items="colors"
                  class="ma-2"
                  v-model="options.color.delete"
                  label="削除"
                ></v-select
              ></v-col>
              <v-col cols="3">
                <v-select
                  :items="colors"
                  class="ma-2"
                  v-model="options.color.submit"
                  label="決定"
                ></v-select
              ></v-col>
            </v-row>
          </div>
          <!---------------- リスト表示   --------------------------->
          <div
            v-else-if="
              rules[1] == 'list' ||
                rules[1] == 'listRev' ||
                rules[1] == 'master' ||
                rules[1] == 'modalTable'
            "
          >
            <v-row v-if="rules[1] != 'master'">
              <p>ボタンの色</p>
              <v-col cols="2">
                <v-select
                  :items="colors"
                  v-model="listButton.add"
                  label="追加"
                ></v-select
              ></v-col>
              <v-col cols="2">
                <v-select
                  :items="colors"
                  v-model="listButton.delete"
                  label="削除"
                ></v-select
              ></v-col>
              <p>ボタン名称</p>
              <v-col cols="2">
                <v-text-field
                  label="追加ボタン"
                  v-model="listButton.addName"
                  :rules="[]"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  label="削除ボタン"
                  v-model="listButton.deleteName"
                  :rules="[]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-checkbox
                  v-model="rules[3]"
                  label="親ページの情報伝達"
                  value="true"
                ></v-checkbox>
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  v-model="rules[4]"
                  label="子ページのsend実行"
                  value="true"
                ></v-checkbox>
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  v-model="rules[5]"
                  label="追加・削除なし"
                  value="true"
                ></v-checkbox>
              </v-col>
              <v-col v-if="rules[5] == 'true'">
                <v-checkbox
                  v-model="rules[18]"
                  label="末尾の追加・削除ボタンだけ表示"
                  value="true"
                ></v-checkbox
              ></v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-checkbox
                  v-model="rules[8]"
                  label="初期生成OFF"
                  value="true"
                ></v-checkbox>
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  v-model="rules[12]"
                  label="行削除無し"
                  value="true"
                ></v-checkbox>
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  v-model="rules[13]"
                  label="子ページの長さ伝達"
                  value="true"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="3"
                v-if="rules[1] == 'list' || rules[1] == 'listRev'"
              >
                <v-checkbox
                  v-model="rules[16]"
                  label="タイトルなし"
                  value="true"
                ></v-checkbox>
              </v-col>
              <v-col cols="3" v-if="rules[1] == 'list'">
                <v-checkbox
                  v-model="rules[17]"
                  label="1行に最大2個表示"
                  value="true"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" v-if="subPageFlag && rules[3] != null">
                <v-checkbox
                  v-model="rules[11]"
                  label="自身が子ページの場合、親の情報を孫に渡す"
                  value="true"
                ></v-checkbox
              ></v-col>
            </v-row>
            <v-row classU="ma-1">
              <v-col cols="5">
                <v-checkbox
                  v-model="rules10flag"
                  label="条件を満たす時、最新のみ表示"
                ></v-checkbox>
              </v-col>
              <v-col cols="2" v-if="rules10flag">
                <v-text-field
                  label="対象formID"
                  v-model="rules10formID"
                  :rules="[varidation.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="4" v-if="rules10flag">
                <v-text-field
                  label="対象文字列"
                  v-model="rules10value"
                  :rules="[varidation.required]"
                  hint="空文字:「null」それ以外:「指定文字列」否定系:「先頭に[半角!]」例)「!null」"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-checkbox
                  v-model="rules15flag"
                  label="リスト型サブページをボタン切り替え表示"
                ></v-checkbox>
              </v-col>
              <v-col cols="6" v-if="rules15flag">
                <v-radio-group label="表示タイプ" v-model="rules15Tmp1">
                  <v-radio
                    label="サブページの特定フォームを横並び表示"
                    value="tablist"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" v-if="rules15flag && rules15Tmp1 == 'tablist'">
                <v-text-field
                  label="一覧表示対象フォームID"
                  v-model.number="rules15_FromID1"
                ></v-text-field>
              </v-col>
              <v-col cols="3" v-if="rules15flag && rules15Tmp1 == 'tablist'">
                <v-select
                  outlined
                  :items="colors"
                  label="色指定(選択中)"
                  v-model="rules15_c1"
                  :rules="[varidation.required]"
                  :background-color="rules15_c1"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" v-if="rules15flag && rules15Tmp1 == 'tablist'">
                <v-text-field
                  label="状態判断対象フォームID(サブページ内)"
                  v-model.number="rules15_FromID2"
                ></v-text-field>
              </v-col>
              <v-col cols="3" v-if="rules15flag && rules15Tmp1 == 'tablist'">
                <v-select
                  :items="colors"
                  outlined
                  label="色指定(完了)"
                  v-model="rules15_c2"
                  :rules="[varidation.required]"
                  :background-color="rules15_c2"
                ></v-select>
              </v-col>

              <v-col cols="3" v-if="rules15flag && rules15Tmp1 == 'tablist'">
                <v-select
                  outlined
                  :items="colors"
                  label="色指定(未完了)"
                  v-model="rules15_c3"
                  :rules="[varidation.required]"
                  :background-color="rules15_c3"
                ></v-select>
              </v-col>
            </v-row>
            <!-- ------------------------------------------------------------->
            <v-row>
              <v-col cols="4">
                <v-text-field
                  label="マスタデータを保存"
                  v-model="rules[9]"
                  :rules="[]"
                ></v-text-field>
              </v-col>
              *1(:)区切り<br />
              *2 マスタページ情報を渡すときは
              [マスタデータ保存formID!マスタページ内主キー!マスタページ内の格納するマスタデータid]
            </v-row>
          </div>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        v-show="showButton"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        fixed
        bottom
        right
        x-large
        class="mr-10 mb-8"
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import searchPage from "../common/searchPage.vue";
export default {
  components: {
    searchPage,
  },
  props: {
    //共通値
    type: Number,
    position: Number,
    label: String,
    //個別値
    init: String,
    rule: String,
    value: String,
  },
  data() {
    return {
      returnData: {
        //共通値
        type: this.type,
        position: this.position,
        label: this.label,
        //個別値
        init: this.init,
        rule: this.rule,
        value: this.value,
      },
      //
      subPageFlag: false,
      backOpacity: "opacity: 1",
      showButton: false,
      rules10flag: false,
      rules10formID: "",
      rules10value: "",
      rules15flag: false,
      rules15Tmp1: "",
      rules15_FromID1: "",
      rules15_FromID2: "",

      rules15_c1: "",
      rules15_c2: "",
      rules15_c3: "",
      //
      rules: {},
      values: [],
      options: {
        color: { add: "", delete: "", submit: "" },
        width: 800,
        height: 200,
      },
      listButton: {
        add: "primary",
        addName: "追加",
        delete: "red",
        deleteName: "削除",
      },
      pageIDs: [],
      //バリデーション
      valid: true,
      colors: [
        "primary",
        "yellow",
        "red",
        "blue",
        "white",
        "yellow lighten-4",
        "blue-grey darken-1",
        "green accent-3",
        "red lighten-4",
        "blue lighten-4",
        "gray",
      ],
      varidation: {
        def: (value) => {
          return /^[\x]*$/.test(value) || "全角スペースが入っています";
        },
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        required: (value) => !!value || "必須項目です",
      },
      headers: [],
    };
  },
  mounted() {
    setTimeout(() => {
      this.showButton = true;
    }, 500);
    this.rules = this.rule.split(",");

    if (this.nullCheck(this.rules[10])) {
      this.rules10flag = true;
      [this.rules10formID, this.rules10value] = this.rules[10].split(".");
    }
    if (this.nullCheck(this.rules[14]) == false) {
      this.rules[14] = "white";
    }
    if (this.nullCheck(this.rules[15])) {
      this.rules15flag = true;
      [
        this.rules15Tmp1,
        this.rules15_FromID1,
        this.rules15_FromID2,
        this.rules15_c1,
        this.rules15_c2,
        this.rules15_c3,
      ] = this.rules[15].split(".");
    }
    this.pageIDs = this.init.split(",");
    if (this.pageIDs.length == 1) {
      this.returnData.init = this.pageIDs[0];
    }
    if (this.rules[1] == "modal" || this.rules[1] == "modalOnlyOne") {
      this.options = JSON.parse(this.value);
    } else if (
      this.rules[1] == "list" ||
      this.rules[1] == "listRev" ||
      this.rules[1] == "master" ||
      this.rules[1] == "modalTable"
    ) {
      if (JSON.parse(this.value).add != undefined) {
        this.listButton = JSON.parse(this.value);
      }
    } else if (this.rules[1] == "multiList") {
      this.values = JSON.parse(this.value);
    }
    //親ページ子ページの判断
    const path = this.$route.path.split("/");
    //subpageFlag
    switch (path[path.length - 1]) {
      case "subreport_builder": //サブページ
        this.subPageFlag = true;
    }
  },
  methods: {
    submit() {
      //バリデーション
      if (this.$refs.form.validate()) {
        if (this.rules[1] != "masterView") {
          this.rules[6] = null;
          this.rules[7] = null;
          if (this.rules[5] != "true") {
            this.rules[18] = null;
          }
        } else {
          this.rules[2] = null;
          this.rules[3] = null;
          this.rules[4] = null;
        }
        if (this.nullCheck(this.rules10flag)) {
          this.rules[10] = this.rules10formID + "." + this.rules10value;
        } else {
          this.rules[10] = null;
        }
        if (this.nullCheck(this.rules15flag)) {
          this.rules[15] =
            this.rules15Tmp1 +
            "." +
            this.rules15_FromID1 +
            "." +
            this.rules15_FromID2 +
            "." +
            this.rules15_c1 +
            "." +
            this.rules15_c2 +
            "." +
            this.rules15_c3;
        } else {
          this.rules[15] = null;
        }
        this.returnData.rule = this.rules.join(",");
        if (this.rules[1] == "modal" || this.rules[1] == "modalOnlyOne") {
          this.returnData.value = JSON.stringify(this.options);
        } else if (
          this.rules[1] == "list" ||
          this.rules[1] == "listRev" ||
          this.rules[1] == "master" ||
          this.rules[1] == "modalTable"
        ) {
          this.returnData.value = JSON.stringify(this.listButton);
        } else if (this.rules[1] == "multiList") {
          this.returnData.value = JSON.stringify(this.values);
          this.returnData.init = this.pageIDs.join(",");
        } else {
          this.returnData.value = "";
        }
        this.$emit("clickSubmit", this.returnData);
      }
    },
    add() {
      this.pageIDs.push(0);
    },
    del() {
      if (this.pageIDs.length > 1) {
        this.pageIDs.splice(-1, 1);
      }
    },
    nullCheck(value) {
      let checkFlag = true;
      switch (value) {
        case "":
        case "undefined":
        case null:
        case undefined:
        case false:
          checkFlag = false;
      }

      return checkFlag;
    },
  },
};
</script>
